// src/pages/PrivacyPolicy.jsx
import React from 'react';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <>
      {/* SEO tags for Privacy Policy page */}
      <title>Privacy Policy | Paisley Dog Gear & Training</title>
      <meta name="description" content="How we collect, use and protect your information when you browse, order or book training." />
      <link rel="canonical" href="https://paisleydoggearandtraining.com/privacy-policy" />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="Privacy Policy | Paisley Dog Gear & Training" />
      <meta property="og:description" content="How we collect, use and protect your information when you browse, order or book training." />
      <meta property="og:url" content="https://paisleydoggearandtraining.com/privacy" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Privacy Policy | Paisley Dog Gear & Training" />
      <meta name="twitter:description" content="How we collect, use and protect your information when you browse, order or book training." />

    
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: July 2025</p>

      <h2>1. Introduction</h2>
      <p>
        Paisley Dog Gear & Training (“we,” “us,” or “our”) operates&nbsp;
        <a href="https://www.paisleydoggearandtraining.com">
          https://www.paisleydoggearandtraining.com
        </a>
        &nbsp;(the “Site”). This Privacy Policy explains how we collect, use,
        and disclose your personal information when you visit our Site.
      </p>

      <h2>2. Information We Collect</h2>
      <ul>
        <li>
          <strong>Personal Data:</strong> Name, email address, and any other
          information you voluntarily submit via contact forms.
        </li>
        <li>
          <strong>Usage Data:</strong> Pages you visit, time on site, referring
          URLs, and other analytics data collected via cookies or similar
          technologies.
        </li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To respond to your inquiries and fulfill training or order requests.</li>
        <li>To improve and personalize your experience on our Site.</li>
        <li>To analyze traffic and usage trends via Google Analytics.</li>
      </ul>

      <h2>4. Sharing & Disclosure</h2>
      <p>
        We do not sell or rent your personal data. We may share your information
        with service providers who help us run the Site (e.g. hosting,
        analytics), all under strict confidentiality agreements.
      </p>

      <h2>5. Cookies & Tracking</h2>
      <p>
        We use cookies and similar tracking technologies to track activity on
        our Site and hold certain information. You can instruct your browser
        to refuse all cookies or to indicate when a cookie is being sent.
      </p>

      <h2>6. Third‑Party Embeds</h2>
      <p>
        We embed Instagram posts on our Site using Meta’s oEmbed API. When you
        load these embeds, Meta may collect usage data under their own privacy
        policy. For details, see&nbsp;
        <a href="https://www.facebook.com/privacy/explanation/">
          Meta’s Privacy Policy
        </a>.
      </p>

      <h2>7. Your Rights</h2>
      <ul>
        <li>
          <strong>Access & Correction:</strong> You can request a copy of your
          personal data or ask us to correct inaccuracies by emailing&nbsp;
          <a href="mailto:jpantano30@gmail.com">jpantano30@gmail.com</a>.
        </li>
        <li>
          <strong>Deletion:</strong> If you’d like us to delete all of your
          personal data, follow the instructions on our&nbsp;
          <a href="/data-deletion">Data Deletion</a> page.
        </li>
      </ul>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will post the
        new version on this page with an updated “Last updated” date.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have questions or concerns about this Privacy Policy, email us
        at&nbsp;
        <a href="mailto:jpantano30@gmail.com">jpantano30@gmail.com</a>.
      </p>
    </div>
    </>
  );
}
